import React from 'react';
import './dayjsGlobal.js';
import { App } from './react/app/components/app/App';
import ReactDOM from 'react-dom';

function bootstrapApp() {
  ReactDOM.render(
    React.createElement(App),
    document.getElementById('root')!
  );
}

bootstrapApp();
